import { ActionTypes } from '../constants';

const initialState = {
  isFetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.DEVICE_ACTIVATION_REQUEST: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case ActionTypes.DEVICE_ACTIVATION_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        isFetching: false,
      };
    }

    case ActionTypes.DEVICE_ACTIVATION_FAILURE: {
      return {
        ...state,
        isFetching: false,
        ...action.payload,
      };
    }
    default:
      return { ...state };
  }
};
